// extracted by mini-css-extract-plugin
export default {"backbutton":"backbutton_backbutton__yI4cs","arrowback":"backbutton_arrowback__PpXTQ"};